import { useEffect, useState } from "react";

import styles from "./StatsBanner.module.css";
import speakersData from "../data/speakers_dyn.json";

export const StatsBanner = () => {
   const [speakerCountRounded, setSpeakerCountRounded] = useState(null);

   useEffect(() => {
      setSpeakerCountRounded(Math.floor(Number(speakersData.speakers.length) / 10) * 10);
   }, []);

   return (
      <div
         className={styles.statsBanner}
         style={{
            position: "absolute",
            top: "calc(72%)",
            left: "0",
            right: "0",
            paddingBottom: "7.5px"
         }}>
         <div
            style={{
               width: "100%",
               display: "flex",
               flexDirection: "column",
               padding: window.innerWidth < 768 ? "2.5% 0%" : "1.5%",
               gap: "2.5vh",
            }}
         >
            <h1
               style={{
                  fontWeight: "bold",
                  textAlign: "center",
                  color: "white",
                  fontSize: window.innerWidth < 769 && "1.25rem",
                  textTransform: "uppercase",
               }}
            >
               Where Innovation Meets Capital<span style={{ verticalAlign: "top", fontWeight: "normal" }}>™</span>
            </h1>
            {speakerCountRounded ? (
               <div
                  style={{
                     display: "flex",
                     color: "white",
                     paddingTop: "0",
                     flexWrap: "nowrap",
                     alignItems: "start",
                     flexDirection: "row",
                     justifyContent: "space-around"
                  }}
               >
                  <div
                     style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        textAlign: "center",
                        width: window.innerWidth < 768 ? "40%" : "",
                        whiteSpace: "nowrap",
                     }}
                  >
                     <h1 style={{
                        fontSize: window.innerWidth < 769 && "1.7rem",
                        fontWeight: "bold"
                     }}>
                        1000+
                     </h1>
                     <h5 style={{ fontSize: window.innerWidth < 769 && ".6rem" }}>
                        Attendees
                     </h5>
                  </div>
                  <span
                     style={{
                        color: "#1070FF",
                        fontSize: window.innerWidth < 900 ? "1.5rem" : "3.8vw",
                        fontWeight: 100,
                     }}
                  >
                     /
                  </span>

                  <div
                     style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        textAlign: "center",
                        width: window.innerWidth < 768 ? "40%" : "",
                        whiteSpace: "nowrap",
                     }}
                  >
                     <h1 style={{
                        fontSize: window.innerWidth < 769 && "1.7rem",
                        fontWeight: "bold"
                     }}>
                        $260B
                     </h1>
                     <h5 style={{ fontSize: window.innerWidth < 769 && ".6rem" }}>
                        Under Management
                     </h5>
                  </div>
                  {
                     <span
                        style={{
                           color: "#0949A8",
                           fontSize: window.innerWidth < 900 ? "1.5rem" : "3.8vw",
                           fontWeight: "100",
                        }}
                     >
                        /
                     </span>
                  }

                  <div
                     style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        textAlign: "center",
                        width: window.innerWidth < 768 ? "40%" : "",
                        whiteSpace: "nowrap",
                     }}
                  >
                     <h1 style={{
                        fontSize: window.innerWidth < 769 && "1.7rem",
                        fontWeight: "bold"
                     }}>
                        {/* 100{" "} */}
                        {speakerCountRounded < 100 ? "100" : speakerCountRounded}
                     </h1>
                     <h5 style={{ fontSize: window.innerWidth < 769 && ".6rem" }}>
                        Featured Investors
                     </h5>
                  </div>
                  {
                     <span
                        style={{
                           color: "#25A4FF",
                           fontSize: window.innerWidth < 900 ? "1.5rem" : "3.8vw",
                           fontWeight: "100",
                        }}
                     >
                        /
                     </span>
                  }
                  <div
                     style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        textAlign: "center",
                        width: window.innerWidth < 768 ? "40%" : "",
                        whiteSpace: "nowrap",
                     }}
                  >
                     <h1 style={{
                        fontSize: window.innerWidth < 769 && "1.7rem",
                        fontWeight: "bold"
                     }}>
                        100
                     </h1>
                     <h5 style={{ fontSize: window.innerWidth < 769 && ".5rem" }}>
                        Top Innovators
                     </h5>
                  </div>
                  <span
                     style={{
                        color: "#00C2FF",
                        fontSize: window.innerWidth < 900 ? "1.5rem" : "3.8vw",
                     }}
                  >
                     /
                  </span>
                  <div
                     style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        textAlign: "center",
                        width: window.innerWidth < 768 ? "40%" : "",
                        whiteSpace: "nowrap",
                     }}
                  >
                     <h1 style={{
                        fontSize: window.innerWidth < 769 && "1.7rem",
                        fontWeight: "bold"
                     }}>
                        2500
                     </h1>
                     <h5 style={{ fontSize: window.innerWidth < 769 && ".6rem" }}>
                        1 on 1 Meetings
                     </h5>
                  </div>
               </div>
            ) : (
               <div style={{ minHeight: "12vh" }}></div>
            )}
         </div>
      </div>
   );
};
